// This store is used to maintain the current active workspace ID
// it _could_ and _should_ be managed via the URL of /workspace/:workspaceId
// but we aren't there yet because of certain routes such as /templates
// which are workspace specific but don't have a workspaceId in the URL and cannot
// because they are SSG'd (soi we cant use dynamic routes)
// we _could_ use a query param but that would be a big change elsewhere
// as we need to then pass the workspaceId around everywhere
// so for now we are using a store
//
// This does mean that if we refresh the page on a url that doesn't have a workspaceId
// we will lose the workspaceId and default to the first workspace
// this is a known and accepted limitation for now

import { create } from 'zustand';

import { LOCAL_STORAGE_LAST_ACTIVE_WORKSPACE_ID } from 'global/constants';

import { WorkspaceStore } from './types';

export const useWorkspaceStore = create<WorkspaceStore>((set) => ({
  activeWorkspaceId: undefined,
  setActiveWorkspaceId: (
    activeWorkspaceId:
      | string
      | undefined
      | ((prev?: string) => string | undefined)
  ) => {
    if (typeof activeWorkspaceId === 'function') {
      set((state) => {
        const id = activeWorkspaceId(state.activeWorkspaceId);
        if (id) {
          localStorage.setItem(LOCAL_STORAGE_LAST_ACTIVE_WORKSPACE_ID, id);
        } else {
          localStorage.removeItem(LOCAL_STORAGE_LAST_ACTIVE_WORKSPACE_ID);
        }
        return {
          activeWorkspaceId: id,
        };
      });
    } else {
      set({ activeWorkspaceId });
      if (activeWorkspaceId) {
        localStorage.setItem(
          LOCAL_STORAGE_LAST_ACTIVE_WORKSPACE_ID,
          activeWorkspaceId
        );
      } else {
        localStorage.removeItem(LOCAL_STORAGE_LAST_ACTIVE_WORKSPACE_ID);
      }
    }
  },
  initialize: () => {
    set({ activeWorkspaceId: undefined });
  },
}));
